/**
 * useAdminAuth Hook
 * 
 * Custom hook for consuming admin authentication context
 */

import { useContext } from 'react';
import { AdminAuthContext } from './AdminAuthProvider.jsx';

/**
 * Hook to access admin authentication context
 * 
 * @returns {Object} Authentication context
 * @property {Object|null} user - Current user object
 * @property {boolean} isAuthenticated - Whether user is authenticated
 * @property {boolean} isLoading - Whether auth state is loading
 * @property {string|null} error - Current error message
 * @property {Function} login - Login function (email, password)
 * @property {Function} logout - Logout function
 * @property {Function} refreshSession - Refresh session tokens
 */
export const useAdminAuth = () => {
  const context = useContext(AdminAuthContext);
  
  if (!context) {
    throw new Error('useAdminAuth must be used within AdminAuthProvider');
  }
  
  return context;
};

export default useAdminAuth;
